import { render, staticRenderFns } from "./Cobranzas.vue?vue&type=template&id=0e144676&"
import script from "./Cobranzas.vue?vue&type=script&lang=js&"
export * from "./Cobranzas.vue?vue&type=script&lang=js&"
import style0 from "./Cobranzas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports